import { useRef } from 'react';
import { Timeline } from './Timeline';
import { VideoStage } from './VideoStage';

/** Owns the shared `<video>` ref so the stage and timeline stay in lockstep. */
export function PreviewSection() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  return (
    <section aria-label="Video preview and trim" className="space-y-3">
      <VideoStage videoRef={videoRef} />
      <Timeline videoRef={videoRef} />
    </section>
  );
}
